import React from 'react'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import styles from './portfolioTeaser.module.scss'

interface Props {
  /** The media name to link to */
  mediaName?: string
}

export const PortfolioTeaser = ({ mediaName }: Props) => {
  const domain = mediaName || parseHostname().publicationName

  return (
    <a
      href={`https://${domain}.ch/567956067068`}
      className={`ui medium centered image ${styles.portfolioTeaser}`}
    >
      <img
        src='https://interaktiv.tagesanzeiger.ch/inline-teaser.gif'
        className='portfolio-teaser'
        alt='Die besten Arbeiten des Interaktiv-Teams: Zur Sammlung'
      />
    </a>
  )
}

